import React from "react";

import IconWrap, { IconWrapProps, iconSizes } from "./IconWrap/IconWrap";
import iconPathRegistry from "./config/iconPathRegistry";

export type Icons = keyof typeof iconPathRegistry;

interface Props extends Omit<IconWrapProps, "children"> {
    icon: Icons;
    size?: keyof typeof iconSizes;
}

const Icon = ({ icon, ...props }: Props) => {
    const IconToRender = iconPathRegistry[icon];
    if (!IconToRender) {
        throw new Error(`This icon is not available - "${icon}"`);
    }

    return (
        <IconWrap {...props}>
            <IconToRender />
        </IconWrap>
    );
};

export default Icon;
